import React, {PureComponent, ReactNode} from 'react';
import {userSignedIn, scrollToTop, isDesktop, getLinkPath} from 'app/utils';
import I18n from 'app/i18n';
import BonusInterfaces from 'app/interfaces/BonusInterface';
import {getImageHeaderByType} from 'app/components/my_profile/bonuses/bonuses_utils';
import {inject, observer} from 'mobx-react';
import {UserBonusesStore} from 'app/store/UserBonusesStore';
import {ArticlesStore} from 'app/store/ArticlesStore';
import {openAuth} from 'app/components/auth/auth';
import {Link} from 'react-router-dom';

interface HeaderBonusesProps {
    bonuses: BonusInterfaces[]
    userBonusesStore?: UserBonusesStore,
    articlesStore?: ArticlesStore
}

const COIN = 'coin';
const COIN_ACTIVE = 'coin-active';
const COIN_INACTIVE = 'coin-inactive';

class HeaderBonuses extends PureComponent<HeaderBonusesProps> {
    handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        scrollToTop();

        if (!userSignedIn()) {
            e.preventDefault();
            openAuth();
        }
    };

    getBonusState() {
        const {bonuses, userBonusesStore, articlesStore} = this.props;
        const activeBonus = bonuses?.find(bonus => bonus.active);
        const hasNotViewedBonuses = userBonusesStore.hasNotViewedBonuses();
        const hasUnviewedPromo = articlesStore.hasUnviewedPromo();
        const hasAvailableBonuses = bonuses?.some(bonus => !bonus.active);
        const hasNewBonuses = hasNotViewedBonuses || hasUnviewedPromo;

        if (!userSignedIn() || hasNewBonuses) {
            return {coinClass: hasUnviewedPromo ? COIN_INACTIVE : '', imgType: COIN, showNewIcon: true};
        }
        if (activeBonus) {
            return {birthday: activeBonus.birthday, coinClass: '', imgType: activeBonus.type, showNewIcon: false};
        }
        if (hasAvailableBonuses) {
            return {coinClass: COIN_ACTIVE, imgType: COIN, showNewIcon: hasNotViewedBonuses};
        }
        return {coinClass: COIN_INACTIVE, imgType: COIN, showNewIcon: false};
    }

    render(): ReactNode {
        const {imgType, showNewIcon, coinClass, birthday} = this.getBonusState();
        const newIconClass = showNewIcon ? ' header__control-new' : '';
        const typeImg = (imgType ?? '').toLowerCase();
        const typeIconCoin = typeImg === 'classic' ? ' gift-icon' : '';
        const typeIconBirthday = typeImg === 'advance' && Boolean(birthday) ? ' birthday-icon' : '';
        const imgByTypeActiveBonuses = getImageHeaderByType(imgType, birthday || false);

        return <div className={`header__control-bonuses ${isDesktop() ? 'header__control' : 'header__mobile-control'}`}>
            <Link
                title={I18n.t('user.my_bonuses')}
                to={getLinkPath('/my_profile/bonuses')}
                className={`header__control-opener header__control-bonuses-opener${newIconClass}`}
                onClick={this.handleClick}
            >
                <img src={imgByTypeActiveBonuses} alt="" className={`header__control-bonuses-img${typeIconCoin}${typeIconBirthday} ${coinClass}`} />
            </Link>
        </div>;
    }
}

export default inject('userBonusesStore', 'articlesStore')(observer(HeaderBonuses));
